import { Button } from "PFComponents/button";
import { Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { HTMLAttributes, useState } from "react";
import { useTranslation } from "react-i18next";

type ErrorMessageWithActionsProps = Pick<HTMLAttributes<HTMLDivElement>, "className"> & {
  message?: string;
};

export const ErrorMessageWithActions = ({ className, message }: ErrorMessageWithActionsProps) => {
  const [showCleanStorageModal, setShowCleanStorageModal] = useState(false);
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" justifyContent="center" gap="spacingLg" className={className}>
      <Icon name="error" size="xxxl" />
      <Typography variant="h2">{message || t("somethingWentWrong")}</Typography>
      <Typography variant="h5">{t("errorBoundary.actionMessage")}</Typography>
      <Inline alignItems="center" justifyContent="center" gap="spacingSm">
        <Button onClick={() => window.location.reload()}>{t("errorBoundary.reload")}</Button>
        <Button kind="secondary" onClick={() => (window.location.href = "mailto:support@profinda.com")}>
          {t("errorBoundary.contactSupport")}
        </Button>
        <Button kind="secondary" onClick={() => setShowCleanStorageModal(true)}>
          {t("errorBoundary.cleanLocalStorage")}
        </Button>

        {showCleanStorageModal && (
          <Modal
            title={t("errorBoundary.cleanLocalStorage")}
            labelOK={t("errorBoundary.clean")}
            onOK={() => {
              window.storage?.clear();
              window.location.reload();
            }}
            onClose={() => setShowCleanStorageModal(false)}
          >
            {t("errorBoundary.cleanStorageWarning")}
          </Modal>
        )}
      </Inline>
    </Stack>
  );
};
